import { SetCompletePartnershipPickupOrderVariables } from '@/api/bff_types';
import { authState } from '@/recoil/auth';
import { setCompletePartnershipPickupOrder } from '@/utils/graphqlApis';
import { useMutation, useQueryClient } from 'react-query';
import { useHistory } from 'react-router-dom';
import { useRecoilValue } from 'recoil';

const useSetCompletePartnershipPickupOrder = () => {
  const history = useHistory();
  const queryClient = useQueryClient();
  const { token } = useRecoilValue(authState);

  const { mutate: setCompletePartnershipPickupOrderMutate } = useMutation(
    (request: SetCompletePartnershipPickupOrderVariables) =>
      setCompletePartnershipPickupOrder(request, token),
    {
      onSuccess: () => {
        history.goBack();
        queryClient.invalidateQueries(['requestedOrders']);
        queryClient.invalidateQueries(['preparingOrders']);
      }
    }
  );
  return {
    setCompletePartnershipPickupOrderMutate
  };
};

export default useSetCompletePartnershipPickupOrder;
